import { c as _c } from "react/compiler-runtime";
import { BigHeader } from "@/components/text/big-header";
import { BigStatement } from "@/components/text/big-statement";
import { BodySimpleVertical } from "@/components/text/body-simple-vertical";
import { getI18nString, getI18nValue, nullToUndefined } from "@/lib/utils";
import type { LayoutHeaderProps } from "./layout-header.types";
export function LayoutHeader(t0) {
  const $ = _c(45);
  const {
    item,
    locale,
    spacing: t1
  } = t0;
  const spacing = t1 === undefined ? "loose" : t1;
  switch (item._type) {
    case "plain":
      {
        return null;
      }
    case "simple":
      {
        let t2;
        if ($[0] !== item.overline || $[1] !== locale) {
          t2 = getI18nString(item.overline, "", locale);
          $[0] = item.overline;
          $[1] = locale;
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        let t3;
        if ($[3] !== item.headline || $[4] !== locale) {
          t3 = getI18nString(item.headline, "", locale);
          $[3] = item.headline;
          $[4] = locale;
          $[5] = t3;
        } else {
          t3 = $[5];
        }
        let t4;
        if ($[6] !== item.bodyCopySimple || $[7] !== locale) {
          t4 = getI18nValue(item.bodyCopySimple, locale);
          $[6] = item.bodyCopySimple;
          $[7] = locale;
          $[8] = t4;
        } else {
          t4 = $[8];
        }
        let t5;
        if ($[9] !== item) {
          t5 = "actions" in item ? nullToUndefined(item.actions) : undefined;
          $[9] = item;
          $[10] = t5;
        } else {
          t5 = $[10];
        }
        let t6;
        if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
          t6 = <BodySimpleVertical overline={t2} headline={t3} body={t4} actions={t5} />;
          $[11] = t2;
          $[12] = t3;
          $[13] = t4;
          $[14] = t5;
          $[15] = t6;
        } else {
          t6 = $[15];
        }
        return t6;
      }
    case "statement":
      {
        let t2;
        if ($[16] !== item.bodyCopySimple || $[17] !== locale) {
          t2 = getI18nValue(item.bodyCopySimple, locale);
          $[16] = item.bodyCopySimple;
          $[17] = locale;
          $[18] = t2;
        } else {
          t2 = $[18];
        }
        const statement = t2;
        if (!statement) {
          return null;
        }
        let t3;
        if ($[19] !== item.overline || $[20] !== locale) {
          t3 = getI18nString(item.overline, "", locale);
          $[19] = item.overline;
          $[20] = locale;
          $[21] = t3;
        } else {
          t3 = $[21];
        }
        let t4;
        if ($[22] !== item.underlineText || $[23] !== locale) {
          t4 = item.underlineText?.map(t => getI18nString(t.text, "", locale)).filter(_temp);
          $[22] = item.underlineText;
          $[23] = locale;
          $[24] = t4;
        } else {
          t4 = $[24];
        }
        let t5;
        if ($[25] !== spacing || $[26] !== statement || $[27] !== t3 || $[28] !== t4) {
          t5 = <BigStatement spacing={spacing} sans={true} overline={t3} statement={statement} underlineItems={t4} />;
          $[25] = spacing;
          $[26] = statement;
          $[27] = t3;
          $[28] = t4;
          $[29] = t5;
        } else {
          t5 = $[29];
        }
        return t5;
      }
    case "bigHeading":
      {
        let t2;
        if ($[30] !== item.headline || $[31] !== locale) {
          t2 = getI18nString(item.headline, "", locale);
          $[30] = item.headline;
          $[31] = locale;
          $[32] = t2;
        } else {
          t2 = $[32];
        }
        const headline = t2;
        if (!headline) {
          return null;
        }
        let t3;
        if ($[33] !== item.overline || $[34] !== locale) {
          t3 = getI18nString(item.overline, "", locale);
          $[33] = item.overline;
          $[34] = locale;
          $[35] = t3;
        } else {
          t3 = $[35];
        }
        let t4;
        if ($[36] !== item.bodyCopySimple || $[37] !== locale) {
          t4 = getI18nValue(item.bodyCopySimple, locale);
          $[36] = item.bodyCopySimple;
          $[37] = locale;
          $[38] = t4;
        } else {
          t4 = $[38];
        }
        const t5 = item.actions?.[0];
        let t6;
        if ($[39] !== headline || $[40] !== spacing || $[41] !== t3 || $[42] !== t4 || $[43] !== t5) {
          t6 = <BigHeader spacing={spacing} overline={t3} headline={headline} body={t4} action={t5} />;
          $[39] = headline;
          $[40] = spacing;
          $[41] = t3;
          $[42] = t4;
          $[43] = t5;
          $[44] = t6;
        } else {
          t6 = $[44];
        }
        return t6;
      }
    default:
      {
        return null;
      }
  }
}
function _temp(text) {
  return Boolean(text);
}